// extracted by mini-css-extract-plugin
export default {"root":"Spinner_root__ouraV","spin":"Spinner_spin__nA6nX","spinnerPathLight":"Spinner_spinnerPathLight__0Zxu0","spinnerPathDark":"Spinner_spinnerPathDark__9tSRt"};